const items = [
  { icon: 'ri-file-list-3-line', text: 'Devis gratuit' },
  { icon: 'ri-shield-check-line', text: 'Garantie 10 ans' },
  { icon: 'ri-timer-flash-line', text: 'Intervention 24-48h' },
  { icon: 'ri-calendar-check-line', text: '7j/7' },
];

export default function ReassuranceBar() {
  return (
    <section className="bg-primary-500 py-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {items.map((item) => (
            <div key={item.text} className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center bg-white/15 rounded-full shrink-0">
                <i className={`${item.icon} text-white text-lg`}></i>
              </span>
              <span className="text-white font-heading font-semibold text-sm md:text-base whitespace-nowrap">
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}